var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"outlined":""}},[_c('v-card-text',{staticClass:"pa-1 body"},[_c('strong',[_vm._v(" "+_vm._s(_vm.input)+" ")]),_c('div',{class:_vm.keyboardClass})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }